import { render, staticRenderFns } from "./district.vue?vue&type=template&id=d202e6b6&scoped=true&"
import script from "./district.vue?vue&type=script&lang=js&"
export * from "./district.vue?vue&type=script&lang=js&"
import style0 from "./district.vue?vue&type=style&index=0&id=d202e6b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d202e6b6",
  null
  
)

export default component.exports